import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { InsertMetric, MetricActionType, MetricAppFeature, MetricAppFeatureSection } from '../entities/insertMetric';
import { AppRequestHeader } from '../entities/appRequestHeader';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { RoleService } from '../../account/services/role.service';
import { AuthenticationService } from '../../account/services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class MetricsService {

  constructor(private httpClient: HttpClient, private translate: TranslateService, private role: RoleService, private auth: AuthenticationService) {
  }

  public submitMetrics(
    actionType: MetricActionType,
    sourceAppFeature: MetricAppFeature, sourceAppFeatureSection: MetricAppFeatureSection,
    targetAppFeature: MetricAppFeature | null = null, targetAppFeatureSection: MetricAppFeatureSection | null = null,
    srcPrimaryValue: string | null = null, srcSecondaryValue: string | null = null,
    tgtPrimaryValue: string | null = null, tgtSecondaryValue: string | null = null,
    metricJson: string | null = null
  ){

    var metric: InsertMetric = {
      MetricAppId: InsertMetric.WebMetricAppId, //This is static to show it comes from the web
      MetricActionTypeId: actionType,
      MetricAppSourceFeatureId: sourceAppFeature,
      MetricAppSourceFeatureSectionId: sourceAppFeatureSection,
      MetricAppTargetFeatureId: targetAppFeature,
      MetricAppTargetFeatureSectionId: targetAppFeatureSection,
      MetricSourcePrimaryValue: srcPrimaryValue,
      MetricSourceSecondaryValue: srcSecondaryValue,
      MetricTargetPrimaryValue: tgtPrimaryValue,
      MetricTargetSecondaryValue: tgtSecondaryValue,
      MetricJson: metricJson
    }

    var header: AppRequestHeader = {
      MobileAppRequestHeader: null,
      WebAppRequestHeader: {
        IPAddress: null,
        Resolution: null
      },
      AppVersion: null,
      DeviceTypeId: 3,
      DeviceOSTypeId: 0,
      DeviceOSVersion: null,
      DeviceDateTime: new Date(),
      MessagingToken: null,
      AppLanguage: this.translate.currentLang,
      DeviceLanguage: null,
      // If not logged in, return 0 for guest
      // Otherwise, user is Private (1) or Business (2)
      Role: this.auth.isLoggedIn() ? (this.role.isPrivateUser() ? 1 : 2) : 0,
      GeoLocation: null
    }

    //Currently passing null as header
    var content = { Input: metric, Header: header };

    //Uses same endpoint as Mobile
    return this.httpClient.post(`${environment.apiUrl}/api/Metrics`, content).subscribe(
      r => {
        if(r == false){
          //Log to Console
        }
      },
      e => {
        //Log to Console
      }
    );
    
  }
}
